export default __webpack_public_path__ + "media/images/word_16px-a460dfee15e472e3f3e4a3e568295f78.png";